import asyncThunk from '@/lib/asyncThunk'

type Request = Record<never, never>

export const signOut = asyncThunk<Request, void>({
  name: 'authentications/sign-out',
  method: 'DELETE',
  uri: '/authentications',
})
